<script setup>
import InsuredDetails from './components/insured-details/insured-details.vue';
import ApplicantDetails from './components/applicant-details/applicant-details.vue';
import FilesSection from './components/files/files-section.vue';

import { toTypedSchema } from '@vee-validate/zod';
import { useForm } from 'vee-validate';

import { EXCUSE_SCHEME } from './scheme';
import { Divider, Form } from 'ant-design-vue';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import { watch, ref, onMounted, nextTick } from 'vue';

import store from '@/store';
import router from '@/router';
import { useRoute, useRouter } from 'vue-router';

const { handleSubmit, resetForm, controlledValues, setValues } = useForm({
    keepValuesOnUnmount: true,
    validationSchema: toTypedSchema(EXCUSE_SCHEME)
});

const toaster = useToast();
const isLoading = ref(false);
const isRestoring = ref(true);
const route = useRoute();

const focusFirstAntdError = () => {
    const items = document.querySelectorAll(".error") || document.querySelectorAll(".error") || document.querySelectorAll(".error");
    items[0].scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(() => items[0].focus(), 300);
};

const handleClearForm = () => {
    scrollTo({ top: 0, behavior: "smooth" });
    localStorage.removeItem("form");
    resetForm();
};

watch(
    controlledValues,
    (newValue) => {
        if (isRestoring.value) {
            return;
        } // пропускаем запись пока восстанавливаем
        localStorage.setItem("form", JSON.stringify(newValue));
    },
    { deep: true }
);

onMounted(async () => {
    const formState = localStorage.getItem("form");

    if (formState) {
        await nextTick();
        setTimeout(() => {
            setValues(JSON.parse(formState), false);
            // Снимаем флаг только после восстановления
            setTimeout(() => { isRestoring.value = false; }, 100);
        }, 0);
    } else {
        isRestoring.value = false;
    }
});

const handleSubmitExcuse = handleSubmit(async (fields) => {
    const formData = new FormData();
    isLoading.value = true;

    const query = route.query;
    console.log(query);

    Object.entries(fields).forEach(([key, value]) => {
        if (value !== undefined) {
            formData.append(key, value);
        }
    });

    formData.append("company_id", query.companyId);

    await axios({
        method: "POST",
        url: "/V1/road-accidents/create-road-accident",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((data) => {
        const infoURL = data.data.data.session_info_link;
        window.open(infoURL, "_blank").focus()
    }).catch(err => {
        if (err.status === 401) {
            store.dispatch('auth/logoutTokenUnactive')
            router.push('/')
            return;
        }
        toaster.error(err.response.data.message)
    }).finally(() => {
        isLoading.value = false;
    });

    toaster.success("Заявление успешно создано");
}, ({ errors }) => {
    setTimeout(focusFirstAntdError, 0);
});
</script>

<template>
    <div class="excuse">
        <h2 class="excuse__title">Страховой случай КАСКО</h2>

        <Form @submit.prevent="handleSubmitExcuse" layout="vertical">
            <ApplicantDetails />
            <InsuredDetails />
            <FilesSection />

            <Divider class="divider" />

            <div class="submit-button-wrapper">
                <button class="clear-form" :disabled="isLoading" type="button" @click="handleClearForm">
                    Очистить форму
                </button>

                <button class="submit-button" :disabled="isLoading" type="submit" @click="handleSubmitExcuse">
                    Подписать с помощью ЭЦП
                </button>
            </div>
        </Form>
    </div>
</template>

<style scoped>
.excuse {
    max-width: 1320px;
    margin: 0 auto;
}

.excuse__title {
    font-family: "Roboto", sans-serif;
    font-size: 24px;
    text-align: center;
    color: #373737;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.divider {
    margin: 50px 0;
}

.clear-form {
    width: 320px;
    border: 2px solid #007BFF;
    color: #007BFF;

    display: flex;
    align-items: center;
    justify-content: center;

    gap: 10px;

    border-radius: 8px;
    background-color: transparent;
    padding: 12px 0;
    transition: all 0.1s ease-in-out;

    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.7;
    }

    & svg path {
        transition: all 0.1s ease-in-out;
    }

    &:not(:disabled):hover {
        background-color: #007BFF;
        color: white;

        svg path {
            stroke: white;
        }
    }
}

.submit-button {
    width: 320px;
    background-color: #007BFF;
    color: white;

    padding: 12px 0;

    border-radius: 8px;

    border: none;
    cursor: pointer;

    background-image: none;

    margin: 0;

    transition: all 0.1s ease-in-out;

    &:not(:disabled):hover {
        background-image: linear-gradient(to right, #F5010A 0%, #1521E9 100%)
    }

    &:disabled {
        background-color: #3c9afd;
        cursor: not-allowed;
    }
}
</style>